import { useTranslation } from "react-i18next";
import React from "react";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import { closeModal } from "../../../../../store/redux/slice/ComponentsControl/referenceDataControl";
import { deleteReferenceData } from "../../../../../axios/api/services";
import { SEARCH_FILTERS_GROUP } from "../../../../../config/search/filters/groupsConfig";
import { useFormContext } from "react-hook-form";
import { onDeleteTableEntrySuccess } from "../../../../../utils/functions";

const DeleteReferenceDataDialog = ({ filterFn, records, total }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { getValues, setValue } = useFormContext();
  const group = SEARCH_FILTERS_GROUP.REFERENCE_DATA;

  const { open, id, domain } = useAppSelector((state) => {
    return state.ComponentsControl.referenceDataControl.modals.delete;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "delete" }));
  };

  const onSuccess = (response) => {
    onDeleteTableEntrySuccess(group, records.length, total, filterFn, dispatch, closeModal, getValues, setValue, t);
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      promiseFunction={() => deleteReferenceData(domain, id)}
      onSuccess={onSuccess}
      title={"t.nomenclature.delete.dialog"}
      message={"m.delete.nomenclature.warning.message"}
    />
  );
};

export default DeleteReferenceDataDialog;
